import { Player } from './player.model';
import { MissingPlayer } from './missing-player.model';
import { Transfer } from './transfer.model';
import { PenaltyStatistic } from './penalty-statistic.model';
import { TeamStatistic } from './team-statistic.model';
import { Match } from './match.model';
import { Team } from './team.model';
import { LastLineupMatch } from './last-lineup-match.model';

export enum MatchSide {
    Home,
    Away
}

export class TeamMatchData {
    teamStatistic: TeamStatistic = new TeamStatistic();
    goals: number = 0;
    players: Player[] = [];
    activePlayers: Player[] = [];
    missingPlayers: MissingPlayer[] = [];
    missingPlayersLoaded: boolean = false;
    transfers: Transfer[] = [];
    transfersLoaded: boolean = false;
    penaltyStatistics: PenaltyStatistic[] = [];
    penaltyStatisticsLoaded: boolean = false;
    goalkeeperPenaltyStatistics: PenaltyStatistic[] = [];
    prevMatches: Match[] = [];
    prevMatchesLoaded: boolean = false;
    nextMatches: Match[] = [];
    nextMatchesLoaded: boolean = false;
    team: Team;
    customLineup: boolean = false;
    lastLineupMatch: LastLineupMatch;
    lastLineupMatchLoaded: boolean = false;
}

export class HomeTeamMatchData extends TeamMatchData {
    matchSide: MatchSide = MatchSide.Home;
    color: string = '#ffffff';
    fontColor: string = 'black';
    overlayOpacity: number = 1;
    invertColorPickerIcon: boolean = true;
}

export class AwayTeamMatchData extends TeamMatchData {
    matchSide: MatchSide = MatchSide.Away;
    color: string = '#214db5';
    fontColor: string = 'white';
    overlayOpacity: number = .55;
    invertColorPickerIcon: boolean = false;
}



// WEBPACK FOOTER //
// ./src/app/shared/team-match-data.model.ts